import { render, staticRenderFns } from "./image.vue?vue&type=template&id=4d35eb80&"
import script from "./image.js?vue&type=script&lang=js&"
export * from "./image.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports